import { Defaults } from 'es-decorators'
import { Collection } from 'es6/components/collection'
import { WishItem } from 'es6/models/wish-item'
import { entryScriptName } from 'init/entry-script-name'

/**
 * Коллекция для избранного
 */
@Defaults({
  model: WishItem,
})
export class Wish extends Collection {
  /**
   * @inheritDoc
   */
  run (options) {
    if (options && options.recommendationsEvents) {
      this.recommendationsEvents = options.recommendationsEvents
      this.listenTo(this, 'add remove', this.sendRecommendationsEvent)
    }
    if (options && options.wishItems) {
      this.wishItems = options.wishItems
    }
  }

  /**
   * Добавляет товары в избранное по списку их id.
   * @param {Array} ids - массив с id товаров.
   */
  addByItemIds (ids) {
    if (ids && ids.length && !this.isStarted) {
      this.isStarted = true
      this.sync('create', this, {
        data: {
          items: ids,
        },
        url: `${entryScriptName}/api/v3/wish/`,
        wait: true,
        method: 'POST',
        success: data => {
          this.isStarted = false
          if (data.wish_items && data.wish_items.length) {
            this.add(data.wish_items)
          }
        },
        processData: true,
      })
    }
  }

  /**
   * Удаляет товары из избранного по списку их id.
   * @param {Array} ids - массив с id товаров.
   */
  deleteByItemsIds (ids) {
    if (ids && ids.length) {
      this.sync('delete', this, {
        url: `${entryScriptName}/api/v3/wish-item/${ids}/`,
        wait: true,
        method: 'DELETE',
        success: () => {
          this.remove(ids)
          if (this.wishItems) {
            this.wishItems.trigger('removeCheckedFromWish', ids.length)
          }
        },
      })
    }
  }

  /**
   * Пробрасываем в GTM события добавления и удаления из избранного
   * @param {WishItem} model
   * @param {Wish} collection
   * @param {Object} options
   */
  sendRecommendationsEvent (model, collection, options) {
    if (options.add) {
      this.recommendationsEvents.trigger('itemInFavorite', model)
    } else {
      this.recommendationsEvents.trigger('itemOutFavorite', model)
    }
  }
}
